/**
 * Transaction History is embedded in ClientDetail as the History tab.
 * No standalone page — resolved in spec §5 (2026-04-03).
 * This route redirects to the client list.
 */
import { Navigate } from 'react-router-dom';

export function TransactionHistoryPage() {
  return <Navigate to="/clients" replace />;
}
